import axios from '../axios'

export const selectUser = params => {
    return axios({
        url: '/v1/user',
        method: 'get',
        params
    })
};